import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
// 移除Vuex导入，仅使用Pinia
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import { createPinia } from 'pinia'
// 导入Element Plus图标
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
// 移除TypeScript类型导入，直接使用JavaScript对象
import './style.css'

// 令牌失效的统一处理
import { ElMessage } from 'element-plus'
import authState from './utils/authState'
import eventBus, { EventTypes } from './utils/eventBus'

// 不再需要创建全局事件总线，直接使用导入的eventBus
// const createEventBus = () => {
//   const events = {};
//   
//   return {
//     events,
//     emit(event, ...args) {
//       if (this.events[event]) {
//         this.events[event].forEach(callback => callback(...args))
//       }
//     },
//     on(event, callback) {
//       if (!this.events[event]) {
//         this.events[event] = []
//       }
//       this.events[event].push(callback)
//     },
//     off(event, callback) {
//       if (this.events[event]) {
//         this.events[event] = this.events[event].filter(cb => cb !== callback)
//       }
//     }
//   }
// }

const app = createApp(App)

// 全局注册所有Element Plus图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 使用导入的eventBus，不再创建新的实例
// const eventBus = createEventBus()

// 全局事件总线插件 - 通过全局属性提供
app.config.globalProperties.$bus = eventBus
// 全局provide注入事件总线 - 通过依赖注入提供
app.provide('bus', eventBus)

// 创建并使用Pinia - 唯一的状态管理库
const pinia = createPinia()
app.use(pinia)

// 移除Vuex初始化

// 注册路由和UI框架
app.use(router)
app.use(ElementPlus)

// 全局令牌监听器
eventBus.on(EventTypes.AUTH_TOKEN_EXPIRED, (data) => {
  console.log('检测到令牌过期事件:', data)
  
  // 如果用户已经登录，显示提示并重定向
    ElMessage.warning(data.message || '您的登录已过期，请重新登录')
    // 保存当前路径，登录后可以重定向回来
    const currentPath = router.currentRoute.value.fullPath
    router.push({
      path: '/login',
      query: { redirect: currentPath }
    })
  
})

// 全局令牌监听，处理在其他选项卡中的令牌变化
window.addEventListener('storage', (event) => {
  if (event.key === 'token') {
    if (!event.newValue && authState.isLoggedIn.value) {
      // 令牌在其他选项卡中被清除，进行登出操作
      console.log('检测到令牌在其他选项卡中被清除，正在进行自动登出')
      authState.logout()
      
      // 显示提示消息
      ElMessage.warning('您的登录已在其他页面失效，请重新登录')
      
      // 如果不是登录页面，则重定向到登录页
      if (router.currentRoute.value.path !== '/login') {
        // 保存当前路径，登录后可以重定向回来
        const currentPath = router.currentRoute.value.fullPath
        router.push({
          path: '/login',
          query: { redirect: currentPath }
        })
      }
    }
  }
})

// 1.禁用右键菜单
document.oncontextmenu = new Function("event.returnValue=false");
// 2.禁用鼠标选中
// document.onselectstart = new Function("event.returnValue=false");
// 3.禁止键盘F12键
// document.addEventListener("keydown", function (e) {
//   if (e.key == "F12") {
//     e.preventDefault(); // 如果按下键F12,阻止事件
//   }
// });

// 应用启动时验证令牌
console.log('应用初始化中 - 正在验证认证状态')
if (authState.token.value) {
  authState.validateToken().then(valid => {
    console.log('令牌验证结果:', valid ? '有效' : '无效')
    
    // 如果令牌无效且用户信息存在，执行登出
    if (!valid && authState.user.value) {
      console.warn('启动时令牌验证失败，执行登出')
      authState.logout()
      
      // 如果不是登录页面，重定向到登录页
      if (router.currentRoute.value.path !== '/login') {
        router.push({ 
          path: '/login',
          query: { redirect: router.currentRoute.value.fullPath }
        })
      }
    }
  }).catch(err => {
    console.error('令牌验证出错:', err)
  })
}

console.log('应用初始化完成 - 状态:', {
  pinia: !!pinia,
  router: !!router,
  elementPlus: !!ElementPlus
})

// 挂载应用
app.mount('#app') 